var _linearGradient, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGmx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 21.462,
    viewBox: "0 0 82.878 21.462",
    width: 82.878,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "objectBoundingBox",
    x1: 0.536,
    x2: 0.011,
    y1: 0.026,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#03d1cf",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e09f8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m555.182 717.462-14.735-21.462-14.78 21.462h20.592l-5.812-8.191-2.883 4.256h-3.064l5.949-8.557 8.6 12.493z",
    fill: "url(#a)",
    transform: "translate(-525.667 -696)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9.216-8.544c-.168 0-.24.072-.24.24v1.44c0 .168.072.24.24.24h4.776v2.524a5.361 5.361 0 0 1 -4.848 2.42c-3.576 0-5.784-2.3-5.784-6.72 0-4.392 2.592-6.72 5.544-6.72 2.3 0 4.176.912 4.776 3.12a.281.281 0 0 0 .288.24h1.532c.168 0 .264-.072.264-.24-.648-3.36-3.528-5.04-6.864-5.04-3.744 0-7.656 2.88-7.656 8.64 0 5.688 3.7 8.64 7.992 8.64a7.468 7.468 0 0 0 6.528-3.456 1.567 1.567 0 0 0 .24-.912v-4.172c0-.168-.072-.24-.24-.24zm24.912-8.016c0-.168-.072-.24-.24-.24h-2.28a.37.37 0 0 0 -.384.24l-4.656 10.68-4.656-10.68a.37.37 0 0 0 -.384-.24h-2.28c-.168 0-.24.072-.24.24v16.32c0 .168.072.24.24.24h1.536c.168 0 .24-.072.24-.24v-13.416l4.7 10.632a.331.331 0 0 0 .312.216h1.064a.331.331 0 0 0 .312-.216l4.7-10.632v13.416c0 .168.072.24.24.24h1.536c.168 0 .24-.072.24-.24zm5.232 0c-.168-.216-.168-.24-.336-.24h-1.848c-.168 0-.24.12-.168.24l5.088 7.7-5.712 8.62c-.072.12 0 .24.168.24h1.8c.168 0 .216-.024.384-.24l4.564-6.86 4.556 6.86c.168.216.216.24.384.24h1.8c.168 0 .24-.12.168-.24l-5.708-8.616 5.088-7.7c.072-.12 0-.24-.168-.24h-1.852c-.168 0-.168.024-.336.24l-3.932 5.924z",
    fill: "#fff",
    transform: "translate(32.642 19.131)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGmx);
export default __webpack_public_path__ + "static/media/logo_GMX.b956aa96299daed10afbd3269f815fbb.svg";
export { ForwardRef as ReactComponent };